var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgexport171(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.0313 0H24.3438L8.90625 22.5624H19.5937L35.0313 0Z",
    fill: "#BF392C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.96875 0H13.6562L29.0936 22.5624H18.4062L2.96875 0Z",
    fill: "#E2574C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.5938 11.875C26.8375 11.875 32.6563 17.6938 32.6563 24.9375C32.6563 32.1812 26.8375 38 19.5938 38C12.35 38 6.53125 32.1812 6.53125 24.9375C6.53125 17.6938 12.35 11.875 19.5938 11.875Z",
    fill: "#E4E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.5938 15.4375C14.3688 15.4375 10.0938 19.7125 10.0938 24.9375C10.0938 30.1626 14.3687 34.4376 19.5938 34.4376C24.8189 34.4376 29.0938 30.1626 29.0938 24.9375C29.0938 19.7125 24.8187 15.4375 19.5938 15.4375ZM19.5938 32.0625C15.675 32.0625 12.4688 28.8562 12.4688 24.9375C12.4688 21.0189 15.6751 17.8126 19.5938 17.8126C23.5124 17.8126 26.7187 21.0189 26.7187 24.9375C26.7187 28.8562 23.5124 32.0625 19.5938 32.0625Z",
    fill: "#CDCFCF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgexport171);
export default __webpack_public_path__ + "static/media/svgexport-17 1.90c29e85d7450e46fe696e811640f6b5.svg";
export { ForwardRef as ReactComponent };